var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClosedOrders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#E9FAE8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 14C22.0716 14 14 22.0716 14 32C14 41.9284 22.0716 50 32 50C41.9284 50 50 41.9284 50 32C50 22.0716 41.9284 14 32 14ZM41.0947 28.2863L30.2189 39.1621C29.9158 39.4653 29.4232 39.4653 29.1579 39.1621L22.9053 32.9095C22.6021 32.6063 22.6021 32.1137 22.9053 31.8484L25.2926 29.4611C25.5958 29.1579 26.0884 29.1579 26.3537 29.4611L29.6884 32.7958L37.6463 24.8379C37.9495 24.5347 38.4421 24.5347 38.7074 24.8379L41.0947 27.2253C41.3979 27.5284 41.3979 27.9832 41.0947 28.2863Z",
    fill: "#3EB93B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedOrders);
export default __webpack_public_path__ + "static/media/closedOrders.1fd1ba8eb986abb6fea8bbf505508e78.svg";
export { ForwardRef as ReactComponent };